import axios from '@/libs/api.request'

/**
 *
 * @returns {wx.RequestTask | never}
 */
export const cleanCache = (params) => {
  return axios.request({
    url: 'systemManage/cleanCache/index',
    method: 'get',
    params: params
  })
}

